import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import actions from './actions';

class ListaQrCode extends Component {
  componentDidMount() {
    this.props.actions.onLoadQrCodes();
  }

  render () {
    let {
      value: { result }
    } = this.props;

    return (<Fragment>
      {result.map((v, i) => (
        <div key={i} className="text-center" style={{
          breakAfter: "always"
        }}>
          <div>
            <h1 style={{margin: 100}}>Diego Rivera</h1>
            {false && <img alt="placeholder" src="http://sohme.com/wp-content/uploads/2015/07/red.png" width="500" height="500" />}
            {true && <img alt={"Código QR para " + v.local} src={"https://chart.googleapis.com/chart?chs=500x500&cht=qr&chld=L|2&chl=" + v.data} />}
            <div>{v.local}</div>
          </div>
        </div>
      ))}
    </Fragment>);
  }
}

let mapStateToProps = ({ agenda }) => ({
  value: agenda.qrcodes
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaQrCode);


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaQrCode.js